import _ from "lodash";

import React, { Component, Fragment } from "react";
export default {
  moduleTableColumns: [
    {
      header: "Name ",
      cell: ({ row }) => {
        const original = row.original;

        return (
          <div style={{ paddingLeft: `${row.depth * 20}px` }}>
            {row.getCanExpand() && (
              <span
                onClick={row.getToggleExpandedHandler()}
                style={{ cursor: "pointer", marginRight: 5 }}
              >
                {row.getIsExpanded() ? "👇" : "👉"}
              </span>
            )}

            {original.type === "module" && original.name}
            {original.type === "trigger" && original.triggerKey}
            {original.type === "recipient" && original.recipientName}
          </div>
        );
      },
    },
    {
      header: "Type / Status",
      cell: ({ row }) => {
        const o = row.original;

        if (o.type === "module" || o.type === "trigger") {
          return o.isActive ? "Active" : "Inactive";
        }

        if (o.type === "recipient") {
          return o.recipientType;
        }

        return "";
      },
    },
    {
      header: "Actions",
      cell: ({ row }) => {
        if (row.original.type === "trigger") {
          return <button>Edit</button>;
        }
        return null;
      },
    },
  ],
  moduleTableColumns: [
    {
      text: "Name",
      dataField: "name",
      tableWidth: 50,
      expandWidth: 50,

      headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
      sort: true,
    },
    {
      text: "Status/Actions",
      dataField: "isActive",
      tableWidth: 50,
      expandWidth: 50,

      headerClasses: "bg-primary text-white px-sm-3 px-2 py-2",
      sort: true,
      formatter: (cellContent, row) => {
        return row.isActive ? "Active" : "Inactive";
      },
    },
  ],
};
